import styled from "styled-components";

export const ContainerTransactionContent = styled.div`
  max-width: 81rem;
  width: 100%;

  display: flex;
  flex-direction: column;

  height: auto;

  gap: 2rem;

  padding-bottom: 2rem;

  > .loader {
    width: fit-content;
    margin: 0 auto;
  }
`;
